import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

type CreatePromotionBody = components["schemas"]["CreatePromotionRequest"];

export function useCreatePromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreatePromotionBody) => {
      const { data, error } = await apiClient.POST("/v1/promotions", { body });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
